import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M 39.8 31.84 L 80 72.04 L 72.04 80 L 39.8 47.76 L 7.96 79.6 L 0 71.64 L 39.8 31.84 z"
    />
  </svg>
);

const IconAccordionUp = (props: IIcon & ReactProps) => <Icon {...props} svg={svg} />;

export default IconAccordionUp;
